const productData=[
    {
        id:1,
        img:"/images/prod1.png",
        rating:"★★★",
        title:"Airpod 131",
        price:1099,
        quantity:1,
    },
    {
        id:2,
        img:"/images/prod2.png",
        rating:"★★★★",
        title:"boAt 228",
        price:649,
        quantity:1,
    },
    {
        id:3,
        img:"/images/prod3.png",
        rating:"★★★★★",
        title:"JBL",
        price:768,
        quantity:1,
    },
    {
        id:4,
        img:"/images/prod4.png",
        rating:"★★★",
        title:"SONY",
        price:1120,
        quantity:1,
    },
    {
        id:5,
        img:"/images/prod5.png",
        rating:"★★★",
        title:"JBL",
        price:989,
        quantity:1,
    },
    {
        id:6,
        img:"/images/prod6.png",
        rating:"★★★★",
        title:"Airpods JBL",
        price:564,
        quantity:1,
    },
    {
        id:7,
        img:"/images/prod7.png",
        rating:"★★★★",
        title:"boAt Headphone",
        price:699,
        quantity:1,
    },
    {
        id:8,
        img:"/images/prod8.png",
        rating:"★★★★★",
        title:"SONY",
        price:1290,
        quantity:1,
    },
]

export default productData;